'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addressValidator = exports.shouldRequireField = exports.shouldHideField = exports.ALL_ADDRESS_FIELDS = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _reactIntl = require('react-intl');

var _validatePostalCode = require('helpers/validatePostalCode');

var _countriesServed = require('constants/countries-served');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIELDS = {
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  country: 'country',
  state: 'state',
  postalCode: 'postalCode'
};
var ALL_ADDRESS_FIELDS = exports.ALL_ADDRESS_FIELDS = (0, _values2.default)(FIELDS);

var messages = (0, _reactIntl.defineMessages)({
  invalidPostalCode: {
    id: 'validations.invalidPostalCode',
    defaultMessage: 'Invalid postal code.'
  },
  required: {
    id: 'validations.genericRequired',
    defaultMessage: 'This field is required.'
  }
});

// We want to hide a field if the API tells us it's unused for a country
var shouldHideField = exports.shouldHideField = function shouldHideField(addressRequirements, fieldName) {
  return addressRequirements && addressRequirements[fieldName] === 'UNUSED';
};

// Currently the API only indicates whether some fields are required or not
// whenever possible we use addressRequirements, and if undefined, assume it's required
var shouldRequireField = exports.shouldRequireField = function shouldRequireField() {
  var addressRequirements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fieldName = arguments[1];
  return addressRequirements && (addressRequirements[fieldName] === 'REQUIRED' || typeof addressRequirements[fieldName] === 'undefined');
};

var appendErrorIfRequired = function appendErrorIfRequired(errors, data, addressRequirements, fieldName) {
  if (shouldRequireField(addressRequirements, fieldName) && !data[fieldName]) {
    errors[fieldName] = messages.required;
  }
};

var appendPostalCodeErrorIfInvalid = function appendPostalCodeErrorIfInvalid(errors, data, addressRequirements) {
  var shortCode = _countriesServed.COUNTRY_CODE_TO_SHORT_CODE[data[FIELDS.country]];
  var postalCodeRequired = shouldRequireField(addressRequirements, FIELDS.postalCode);
  if (postalCodeRequired && shortCode && !(0, _validatePostalCode.isPostalCode)(data[FIELDS.postalCode], shortCode)) {
    errors.postalCode = messages.invalidPostalCode;
  }
};

var addressValidator = exports.addressValidator = function addressValidator() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var errors = {};
  appendPostalCodeErrorIfInvalid(errors, data, props.addressRequirements);
  var addErrorIfRequired = appendErrorIfRequired.bind(null, errors, data, props.addressRequirements);
  ALL_ADDRESS_FIELDS.forEach(addErrorIfRequired);

  return errors;
};